import type { cardDelivery } from '@bb/contracts';

const OPTIONS: Array<{ value: cardDelivery.CardCreationMode; label: string; hint: string }> = [
  {
    value: 'first_impression',
    label: 'At first impression (recommended)',
    hint: 'The card is created when the user next opens the feed: the audience is checked again and the content uses the data of that moment. Users who left the audience get nothing.',
  },
  {
    value: 'step_entry',
    label: 'At step entry',
    hint: 'The card is created as soon as the user enters the step or the campaign sends, with the data of that moment.',
  },
];

/**
 * Card creation mode of a Content Card message (BB-63) for the card composer (BB-62) and the Canvas Message step
 * (BB-115). The mode is fixed once the campaign or Canvas is launched: pass `locked` for a launched revision;
 * `disabled` for a form that is read-only for another reason.
 */
export function CardCreationModeField({ value, onChange, locked = false, disabled = false }: { value: cardDelivery.CardCreationMode; onChange: (mode: cardDelivery.CardCreationMode) => void; locked?: boolean; disabled?: boolean }) {
  return (
    <fieldset aria-label="Card creation">
      <legend>Card creation</legend>
      {OPTIONS.map((o) => (
        <label key={o.value}>
          <input type="radio" name="card-creation-mode" value={o.value} checked={value === o.value} disabled={locked || disabled} onChange={() => onChange(o.value)} /> {o.label}
          <span className="hint">{o.hint}</span>
        </label>
      ))}
      {locked && <p className="hint">The creation mode cannot change after launch.</p>}
    </fieldset>
  );
}
